export default "__VITE_ASSET__CtARdaVu__"